"use strict";
/*
  firebase에서, Login Provider type을 'google.com', 'apple.com' 형태로 받고 있으므로,
  face wallet에서도 Login Provider를 firebase와 동일한 형태로 사용하고 있습니다.
*/
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=auth.js.map